import { render } from "./CommentColumn.vue?vue&type=template&id=22a0f38d"
import script from "./CommentColumn.vue?vue&type=script&lang=js"
export * from "./CommentColumn.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CommentColumn.vue?vue&type=style&index=0&id=22a0f38d&lang=module.css&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__